import { components, GroupBase, DropdownIndicatorProps } from 'react-select';
import * as Colors from '../../../constants/Colors';
import { ChevronIcon } from '../../../icons';

export const DropdownIndicator = <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>(
    props: DropdownIndicatorProps<Option, IsMulti, Group>
) => (
    <components.DropdownIndicator {...props}>
        <ChevronIcon
            direction={props.selectProps.menuIsOpen ? 'up' : 'down'}
            color={Colors.purple}
            margin="0 8px 0 0"
            cursor="pointer"
        />
    </components.DropdownIndicator>
);
